import { render, staticRenderFns } from "./Supermarket.vue?vue&type=template&id=7dc79d70"
import script from "./Supermarket.vue?vue&type=script&lang=js"
export * from "./Supermarket.vue?vue&type=script&lang=js"
import style0 from "./Supermarket.vue?vue&type=style&index=0&id=7dc79d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports